export default "__VITE_ASSET__WVQ8sZjY__"